import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Επιβεβαίωση Διαγραφής',
  message = 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το στοιχείο;',
  itemName = null,
  loading = false,
  confirmText = 'Διαγραφή',
  cancelText = 'Ακύρωση'
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: 'error.main',
        fontWeight: 600
      }}>
        <WarningIcon />
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>
        
        {itemName && (
          <Box sx={{ 
            p: 2, 
            backgroundColor: 'grey.50',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'grey.200'
          }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              Στοιχείο προς διαγραφή:
            </Typography>
            <Typography variant="body1" fontWeight={500}>
              {itemName}
            </Typography>
          </Box>
        )}

        <Typography 
          variant="body2" 
          color="error.main" 
          sx={{ mt: 2, fontWeight: 500 }}
        >
          ⚠️ Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={onClose}
          disabled={loading}
          variant="outlined"
        >
          {cancelText}
        </Button>
        <Button 
          onClick={handleConfirm}
          disabled={loading}
          variant="contained"
          color="error"
          startIcon={loading && <CircularProgress size={16} />}
        >
          {loading ? 'Διαγραφή...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;